import Card from 'antd-mobile/lib/card';
export default Card;



// WEBPACK FOOTER //
// ./components/card/index.tsx